import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('EGSNews').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '90%',
    overflow: 'hidden',
    height: '120px',
    borderRadius: '12px',
    boxShadow: '2px 0px 10px 0px rgba(0, 0, 0, 0.20)',
    backgroundImage: 'url(/assets/backgrounds/egsplate.webp)',
    backgroundSize: '110%',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    p: {
      margin: 0,
      cursor: 'pointer',
      pointerEvents: 'none',
      fontSize: theme.sizes.texts.fontSize.m,
      lineHeight: theme.sizes.texts.lineHeight.m,
      textAlign: 'left',
      maxWidth: '50%',
      position: 'absolute',
      left: '5%',
      bottom: '15%',
    },
  },

  title: {
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: theme.sizes.texts.fontSize.xl,
    lineHeight: theme.sizes.texts.lineHeight.xl,
    color: theme.colors.text.primary,
  },
  description: {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.l,
    color: theme.colors.text.primary,
  },
}))
